import { REFERRAL_CODE_PATTERN } from '@repo/domain';

const REFERRAL_CODE_STORAGE_KEY = 'referral-code-v1';
const REFERRAL_CODE_QUERY_PARAM = 'ref';

export const getStoredReferralCode = (): string | undefined => {
  const stored = window.localStorage.getItem(REFERRAL_CODE_STORAGE_KEY)?.trim();
  return stored ? stored : undefined;
};

const setStoredReferralCode = (code: string): void => {
  window.localStorage.setItem(REFERRAL_CODE_STORAGE_KEY, code);
};

export const clearStoredReferralCode = (): void => {
  window.localStorage.removeItem(REFERRAL_CODE_STORAGE_KEY);
};

/**
 * Reads the referral code from the current URL (e.g. an invite link
 * `/start-earning?ref=CODE`) and persists it so it can be applied once the
 * user registers. Safe to call on every app load.
 */
export const captureReferralCodeFromUrl = (): void => {
  const params = new URLSearchParams(window.location.search);
  const code = params.get(REFERRAL_CODE_QUERY_PARAM)?.trim();
  if (code && REFERRAL_CODE_PATTERN.test(code)) {
    setStoredReferralCode(code);
  }
};
